module.exports = __webpack_public_path__ + "img/logo.4868c579.svg";